import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Form, Radio, Switch } from 'antd';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import styles from './style.module.less';
const AvailabilitySettings = ({ disabled = false, rules, hidden = {}, applyDefaultSpeakerId = false, }) => {
    const { session, session: { teamSettings } } = useSession();
    const isSpeakerIdEnabled = session.login.hasClaim('speakerId:enabled');
    const form = Form.useFormInstance();
    const availability = Form.useWatch('availability');
    useEffect(() => {
        if (availability === undefined || disabled || hidden.speakerIdActive === true) {
            return;
        }
        if (availability !== 'all') {
            form.setFieldValue('speakerIdActive', false);
        }
        else if (isSpeakerIdEnabled && applyDefaultSpeakerId) {
            form.setFieldValue('speakerIdActive', teamSettings.speakerIdDefault);
        }
    }, [availability]);
    return (_jsxs(_Fragment, { children: [_jsx(Form.Item, { name: "availability", label: txt('availability'), rules: rules, hidden: hidden.availability, children: _jsx(Radio.Group, { disabled: disabled, className: styles.radioGroup, size: "small", options: [
                        { label: txt('onlyThisProject'), value: 'current' },
                        { label: txt('allProjects'), value: 'all' },
                    ] }) }), isSpeakerIdEnabled && (_jsx(Form.Item, { name: "speakerIdActive", label: txt('trainAutodetection'), tooltip: disabled && txt('speakerDisableTooltip'), hidden: availability !== 'all' || hidden.speakerIdActive, children: _jsx(Switch, { disabled: disabled, size: "small" }) }))] }));
};
export default AvailabilitySettings;
